<template>
    <div>
        <v-container grid-list-xl fluid fill-height>
            <v-layout row wrap :justify-center="$bp.xs">
                <v-flex style="flex-grow:0; flex-basis: 0;">
                    <v-card tile height="200" width="250" class="text-xs-center elevation-10 clickable" @mouseup.left="showPhone()">
                        <v-icon color="primary" style="margin-top:82px;" size="36">add</v-icon>
                    </v-card>
                </v-flex>
                <v-flex
                    v-for="(phone, index) in phones"
                    :key="index"
                    style="flex-grow:0; flex-basis: 0;"
                >
                    <v-card height="200" width="250" class="subheading text-xs-center py-3 elevation-10 clickable" @mouseup.left="showPhone(phone)">
                        <v-icon size="36" fill-height color="primary">phone</v-icon>
                        <v-flex class="pa-1">{{ phone.phone_number_formatted ? phone.phone_number_formatted : phone.phone_number }}</v-flex>
                        <v-flex class="pa-1">{{ $t(`lang.${phone.phone_type}`) }}</v-flex>
                        <v-chip color="primary" class="my-2 pa-1 body-2 white--text" v-if="phone.prime == true" disabled>{{ $t('lang.primary_caps') }}</v-chip>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <bc-phone-dialog
            ref="phoneDialog"
            :getFunction="getFunction"
            entity_object="me"
            :total_items="phones ? phones : null"
        ></bc-phone-dialog>
    </div>
</template>

<script>
    export default {
        props: [ "phones", "getFunction"],
        methods: {
            showPhone(phone = null){
                this.$refs.phoneDialog.showPhone(phone)
            }
        }
    };
</script>